var HrReportComponent = (function () {
    function HrReportComponent() {
    }
    HrReportComponent.prototype.ngOnInit = function () {
        this.page = "overview";
    };
    return HrReportComponent;
}());
export { HrReportComponent };



// WEBPACK FOOTER //
// ./src/app/hr-report.component.ts.pre-build-optimizer.js